import { AccountController } from "@/app/ui/controllers/AccountController";
import moment from "moment";
import { configDates } from "../modules/Date";
import getUserTimezone from "./GetUserTimezone";

const formatDate = (
  date: any,
  format = "DD MMMM YYYY, HH:mm",
  parseZone = true,
  locale?: string,
  appendTzLabel = true
) => {
  if (!date) return "-";

  const formatWithLocale = (d: any, fmt: string, useParseZone = false) => {
    const m = useParseZone ? moment.parseZone(d) : moment(d);
    const withLocale = locale ? m.locale(locale) : m;
    return withLocale.format(fmt);
  };

  if (parseZone) {
    const locales: string = AccountController.accountData?.countryCode || "id";

    const searchGMT = new Date(date).toString().search("GMT");
    const UTC = new Date(date).toString().slice(searchGMT, searchGMT + 8);
    const labels = configDates(UTC);
    const localeKey = locales.toLowerCase();
    const tzLabel = appendTzLabel
      ? localeKey in labels
        ? labels[localeKey]
        : labels.id ?? ""
      : "";
    return date
      ? formatWithLocale(date, format) + (tzLabel ? ` ${tzLabel}` : "")
      : "-";
  }

  if (!parseZone) {
    return `${formatWithLocale(date, format, true)} ${getUserTimezone()}`;
  }

  return date;
};
export default formatDate;
